import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'
import * as routeKeys from 'constants/RoutesKeys'

export const publicRoutes = [
  {
    key: 'login',
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import('views/auth-views/authentication/login')
    ),
  },
  {
    key: 'login-1',
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import('views/auth-views/authentication/login-1')
    ),
  },
  {
    key: 'login-2',
    path: `${AUTH_PREFIX_PATH}/login-2`,
    component: React.lazy(() =>
      import('views/auth-views/authentication/login-2')
    ),
  },
  {
    key: 'register-1',
    path: `${AUTH_PREFIX_PATH}/register-1`,
    component: React.lazy(() =>
      import('views/auth-views/authentication/register-1')
    ),
  },
  {
    key: 'register-2',
    path: `${AUTH_PREFIX_PATH}/register-2`,
    component: React.lazy(() =>
      import('views/auth-views/authentication/register-2')
    ),
  },
  {
    key: 'forgot-password',
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import('views/auth-views/authentication/forgot-password')
    ),
  },
  {
    key: 'error-page-1',
    path: `${AUTH_PREFIX_PATH}/error-1`,
    component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
  },
  {
    key: 'error-page-2',
    path: `${AUTH_PREFIX_PATH}/error-2`,
    component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
  },
]

export const protectedRoutes = [
  // Template / demo sections (no permission gate)
  {
    key: 'apps',
    isPage: true,
    path: `${APP_PREFIX_PATH}/apps/*`,
    component: React.lazy(() => import('views/app-views/apps')),
  },
  {
    key: 'components',
    isPage: true,
    path: `${APP_PREFIX_PATH}/components/*`,
    component: React.lazy(() => import('views/app-views/components')),
  },
  {
    key: 'charts',
    isPage: true,
    path: `${APP_PREFIX_PATH}/charts/*`,
    component: React.lazy(() => import('views/app-views/charts')),
  },
  {
    key: 'maps',
    isPage: true,
    path: `${APP_PREFIX_PATH}/maps/*`,
    component: React.lazy(() => import('views/app-views/maps')),
  },
  {
    key: 'docs',
    isPage: true,
    path: `${APP_PREFIX_PATH}/docs/*`,
    component: React.lazy(() => import('views/app-views/docs')),
  },
  {
    key: 'dashboard-profile',
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/profile/*`,
    component: React.lazy(() => import('views/app-views/dashboards/profile')),
  },
  {
    key: 'pages-profile',
    isPage: true,
    path: `${APP_PREFIX_PATH}/pages/profile/*`,
    component: React.lazy(() => import('views/app-views/pages/profile')),
  },
  {
    key: 'pages-invoice',
    isPage: true,
    path: `${APP_PREFIX_PATH}/pages/invoice/*`,
    component: React.lazy(() => import('views/app-views/pages/invoice')),
  },
  {
    key: 'pages-pricing',
    isPage: true,
    path: `${APP_PREFIX_PATH}/pages/pricing/*`,
    component: React.lazy(() => import('views/app-views/pages/pricing')),
  },
  {
    key: 'pages-faq',
    isPage: true,
    path: `${APP_PREFIX_PATH}/pages/faq/*`,
    component: React.lazy(() => import('views/app-views/pages/faq')),
  },
  {
    key: 'pages-setting',
    isPage: true,
    path: `${APP_PREFIX_PATH}/pages/setting/*`,
    component: React.lazy(() => import('views/app-views/pages/setting')),
  },
  {
    key: 'pages-user-list',
    isPage: true,
    path: `${APP_PREFIX_PATH}/pages/user-list/*`,
    component: React.lazy(() => import('views/app-views/pages/user-list')),
  },
  // Business modules
  {
    key: 'dashboard.default',
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import('views/app-views/dashboards/default/index.js')),
  },
  {
    key: routeKeys.subadminsKey,
    path: `${APP_PREFIX_PATH}/admins/subadmins/*`,
    component: React.lazy(() => import('views/app-views/admins/subadmins')),
  },
  {
    key: routeKeys.subadminRolesKey,
    path: `${APP_PREFIX_PATH}/admins/subadmin-roles/*`,
    component: React.lazy(() =>
      import('views/app-views/admins/subadmin-roles')
    ),
  },
  {
    key: routeKeys.templateKey,
    path: `${APP_PREFIX_PATH}/pages/template/*`,
    component: React.lazy(() => import('views/app-views/pages/template')),
  },
  {
    key: routeKeys.informationPolicyKey,
    path: `${APP_PREFIX_PATH}/pages/information-policy/*`,
    component: React.lazy(() =>
      import('views/app-views/pages/information-policy')
    ),
  },
  {
    key: routeKeys.pagesKey,
    path: `${APP_PREFIX_PATH}/pages/pages/*`,
    component: React.lazy(() => import('views/app-views/pages/pages')),
  },
  {
    key: routeKeys.adminSettingsKey,
    path: `${APP_PREFIX_PATH}/pages/admin-settings/*`,
    component: React.lazy(() =>
      import('views/app-views/pages/admin-settings')
    ),
  },
  {
    key: routeKeys.configSettingsKey,
    path: `${APP_PREFIX_PATH}/pages/config-settings/*`,
    component: React.lazy(() =>
      import('views/app-views/pages/config-settings')
    ),
  },
  {
    key: routeKeys.notificationKey,
    path: `${APP_PREFIX_PATH}/pages/notification/*`,
    component: React.lazy(() =>
      import('views/app-views/pages/notification')
    ),
  },
  {
    key: routeKeys.bannerKey,
    path: `${APP_PREFIX_PATH}/pages/banners/*`,
    component: React.lazy(() => import('views/app-views/pages/banners')),
  },
  {
    key: routeKeys.contactUsKey,
    path: `${APP_PREFIX_PATH}/pages/contact-us/*`,
    component: React.lazy(() => import('views/app-views/pages/contact-us')),
  },
  {
    key: routeKeys.seoKey,
    path: `${APP_PREFIX_PATH}/pages/seo/*`,
    component: React.lazy(() => import('views/app-views/pages/seo')),
  },
  {
    key: routeKeys.widgetsKey,
    path: `${APP_PREFIX_PATH}/pages/widgets/*`,
    component: React.lazy(() => import('views/app-views/pages/widgets')),
  },
  {
    key: routeKeys.categoriesKey,
    path: `${APP_PREFIX_PATH}/pages/categories/*`,
    component: React.lazy(() => import('views/app-views/pages/categories')),
  },
  {
    key: routeKeys.countryKey,
    path: `${APP_PREFIX_PATH}/pages/country-list/*`,
    component: React.lazy(() => import('views/app-views/pages/country')),
  },
  {
    key: routeKeys.stateKey,
    path: `${APP_PREFIX_PATH}/pages/state-list/*`,
    component: React.lazy(() => import('views/app-views/pages/state')),
  },
  {
    key: routeKeys.galleryKey,
    path: `${APP_PREFIX_PATH}/pages/gallery/*`,
    component: React.lazy(() => import('views/app-views/pages/gallery')),
  },
  {
    key: routeKeys.officialContactKey,
    path: `${APP_PREFIX_PATH}/pages/official-contact/*`,
    component: React.lazy(() => import('views/app-views/pages/official-contact')),
  },
  {
    key: routeKeys.administrationKey,
    path: `${APP_PREFIX_PATH}/pages/administration/*`,
    component: React.lazy(() => import('views/app-views/pages/administration')),
  },
  {
    key: routeKeys.parishPriestKey,
    path: `${APP_PREFIX_PATH}/pages/parish-priest/*`,
    component: React.lazy(() => import('views/app-views/pages/parish-priest')),
  },
  {
    key: routeKeys.leadershipHistoryKey,
    path: `${APP_PREFIX_PATH}/pages/leadership-history/*`,
    component: React.lazy(() => import('views/app-views/pages/leadership-history')),
  },
  {
    key: routeKeys.houseKey,
    path: `${APP_PREFIX_PATH}/pages/house/*`,
    component: React.lazy(() => import('views/app-views/pages/house')),
  },
  {
    key: routeKeys.historyKey,
    path: `${APP_PREFIX_PATH}/pages/history/*`,
    component: React.lazy(() => import('views/app-views/pages/history')),
  },
  {
    key: routeKeys.hierarchyKey,
    path: `${APP_PREFIX_PATH}/pages/hierarchy/*`,
    component: React.lazy(() => import('views/app-views/pages/hierarchy')),
  },
  {
    key: routeKeys.positionKey,
    path: `${APP_PREFIX_PATH}/pages/position/*`,
    component: React.lazy(() => import('views/app-views/pages/position')),
  },
  {
    key: routeKeys.churchKey,
    path: `${APP_PREFIX_PATH}/pages/church/*`,
    component: React.lazy(() => import('views/app-views/pages/church')),
  },
  {
    key: routeKeys.organizationKey,
    path: `${APP_PREFIX_PATH}/pages/organization/*`,
    component: React.lazy(() => import('views/app-views/pages/organization')),
  },
  {
    key: routeKeys.membersKey,
    path: `${APP_PREFIX_PATH}/pages/members/*`,
    component: React.lazy(() => import('views/app-views/pages/members')),
  },
  {
    key: routeKeys.chapelKey,
    path: `${APP_PREFIX_PATH}/pages/chapel/*`,
    component: React.lazy(() => import('views/app-views/pages/chapel')),
  },
  {
    key: routeKeys.newsKey,
    path: `${APP_PREFIX_PATH}/pages/news/*`,
    component: React.lazy(() => import('views/app-views/pages/news')),
  },
  {
    key: routeKeys.festivalsKey,
    path: `${APP_PREFIX_PATH}/pages/festivals/*`,
    component: React.lazy(() => import('views/app-views/pages/festivals')),
  },
  {
    key: routeKeys.advertisementKey,
    path: `${APP_PREFIX_PATH}/pages/advertisement/*`,
    component: React.lazy(() => import('views/app-views/pages/advertisement')),
  },
  {
    key: routeKeys.occasionKey,
    path: `${APP_PREFIX_PATH}/pages/occasion/*`,
    component: React.lazy(() => import('views/app-views/pages/occasion')),
  },
  {
    key: routeKeys.liveStreamingKey,
    path: `${APP_PREFIX_PATH}/pages/live-streaming/*`,
    component: React.lazy(() => import('views/app-views/pages/live-streaming')),
  },
  {
    key: routeKeys.incomePdfLinkKey,
    path: `${APP_PREFIX_PATH}/pages/income-pdf-link/*`,
    component: React.lazy(() => import('views/app-views/pages/income-pdf-link')),
  },
  {
    key: routeKeys.eventsKey,
    path: `${APP_PREFIX_PATH}/pages/events/*`,
    component: React.lazy(() => import('views/app-views/pages/events')),
  },
  {
    key: routeKeys.quotesKey,
    path: `${APP_PREFIX_PATH}/pages/quotes/*`,
    component: React.lazy(() => import('views/app-views/pages/quotes')),
  },
]
